import "./index.scss";
import "array-flat-polyfill";
import {Api, MinorCurrencyRatio} from "@hps/hops-sdk-js";
import * as Sentry from "@sentry/react";
import React from "react";
import ReactDOM from "react-dom";

import App from "App/App.js";

/**
 * Sentry integration
 */
if (process.env.REACT_APP_SENTRY_DSN) {
	Sentry.init({
		dsn: process.env.REACT_APP_SENTRY_DSN,
		release: process.env.REACT_APP_APP
	});
}

/**
 * Development override for HOPS API base URL
 */
if (process.env.REACT_APP_HOPS_API_BASE_URL) {
	Api.baseURL = process.env.REACT_APP_HOPS_API_BASE_URL;
}

/**
 * Localisation
 */
Api.locale = "en-gb";
Api.currencyUnit = "GBP";
Api.minorUnitDivisor = MinorCurrencyRatio.Two;

/**
 * Render the React app!
 */
ReactDOM.render(<App />, document.getElementById("react"));
